<template>
  <div class="blog-page">
    <HeroSection
      v-model:searchQuery="searchQuery"
      :title="heroTitle"
      :subtitle="heroSubtitle"
      :searchLabel="searchLabel"
      :backgroundImage="backgroundImage"
      :heroSubtitleMob="heroSubtitleMob"

    />
    <BlogListSection
      :searchQuery="searchQuery"
      :items="allBlogs"
      :status="status"
      :filters="filters"
      :activeFilter="activeFilter"
      v-model:page="page"
      :totalItems="totalBlogs"
      :limit="limit"
      :showFilters="false"
      :cardComponent="BlogCard"
      :setFilter="setFilter"
      :fetchItems="fetchBlogs"
      :routePath="routePath"
      @clearSearchInput="clearSearchInput"
      :notFoundTitle="notFoundTitle"
      :notFoundHint="notFoundHint"
    />
    <Newsletter />
    <GetInTouch :backgroundColor="'#DEF3FF'" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import HeroSection from '../partials/HeroSection.vue';
import BlogListSection from '../partials/CardListSection.vue';
import Newsletter from '../partials/Newsletter.vue';
import GetInTouch from './../../service/components/GetInTouch.vue';
import GenericCard from '../partials/Card.vue';
import experienceNepalService from '@/services/API/experienceNepalService';

const BlogCard = GenericCard; // Alias for clarity

const searchQuery = ref('');
const heroTitle = ref('Experience Nepal');
const heroSubtitle = ref(
  "Discover Nepal through its vibrant festivals, rich traditions, and timeless cultural stories—celebrating</br> what makes this nation truly unique"
);
const heroSubtitleMob = ref("Discover Nepal through its vibrant festivals, rich traditions, and timeless cultural stories—celebrating what makes this nation truly unique");
const searchLabel = ref('Search cultural and festive stories');
const backgroundImage = ref(require('@/assets/img/experience-nepal-bg.svg'));
const routePath = ref('/experience-nepal'); // Define the route path

const notFoundTitle = ref('No stories found'); // Custom title
const notFoundHint = ref("We couldn’t find any cultural or festive stories matching your search. Try a different keyword or explore other moments from Nepal’s rich traditions.");

const allBlogs = ref([]);
const status = ref('loading');
const activeFilter = ref('all');
const page = ref(1);
const totalBlogs = ref(0);
const limit = 12;
const filters = ref([
  { id: 'all', label: 'All Posts' },
  { id: 'software', label: 'Software' },
]);

const totalPages = computed(() => Math.ceil(totalBlogs.value / limit));

const fetchExperiences = async (key = searchQuery.value) => {
  try {
    status.value = 'loading';
    const res = await experienceNepalService.listAllExperience(
      activeFilter.value,
      key,
      page.value - 1
    );
    if (res.status === 200) {
      console.log(allBlogs);
      allBlogs.value = res.data.data;
      totalBlogs.value = res.data.total;
    } else {
      allBlogs.value = [];
    }
    status.value = 'success';
  } catch (e) {
    status.value = 'error';
    console.log(e);
  }
};

const setFilter = (filterId) => {
  activeFilter.value = filterId;
  page.value = 1;
  fetchExperiences();
};

const clearSearchInput = () => {
  searchQuery.value = '';
};

watch(searchQuery, async (newKey) => {
  await fetchExperiences(newKey);
  page.value = 1;
});

watch(page, async () => {
  await fetchExperiences();
});

onMounted(async () => {
  await fetchExperiences();
});
</script>
